"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = mapToMegaFormProps;
const jsx_runtime_1 = require("react/jsx-runtime");
const gatsby_theme_leshen_1 = require("@leshen/gatsby-theme-leshen");
function mapToMegaFormProps({ data, mappers, packages, forms, }) {
    let megaFormDisclaimer = null;
    let formDisclaimer = null;
    const megaForm = typeof data.megaFormReference === 'object' &&
        data.megaFormReference !== null
        ? data.megaFormReference
        : null;
    const form = megaForm?.form && typeof megaForm.form === 'object'
        ? megaForm.form
        : null;
    const formId = form && 'formGuid' in form ? form.formGuid : '';
    if (typeof megaForm?.megaFormDisclaimer !== 'number' &&
        megaForm?.megaFormDisclaimer?.brandyRaw) {
        megaFormDisclaimer = megaForm?.megaFormDisclaimer?.brandyRaw;
    }
    if (typeof form?.disclaimers !== 'number' && form?.disclaimers?.brandyRaw) {
        formDisclaimer = form?.disclaimers.brandyRaw;
    }
    const emilyForm = forms && forms[formId];
    return {
        children: ((0, jsx_runtime_1.jsx)(gatsby_theme_leshen_1.Columns, { children: megaForm?.items?.map((item) => ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: mappers.mapBlock({
                    block: item || [],
                    mappers,
                    packages,
                }) }))) })),
        megaFormDisclaimer,
        disclaimer: {
            brandy: formDisclaimer,
        },
        stepsData: gatsby_theme_leshen_1.StepsData,
        heading: form && form.heading,
        subheading: form && form.subheading,
        tcpaCheckbox: form && form.tcpaCheckbox,
        fields: emilyForm?.formFields,
        formName: emilyForm?.name || null
    };
}
